import type { ReactNode } from "react";
import { useMemo } from "react";
import useQuestionResponse from "../useQuestionResponse";
import { CommentContext } from "./CommentContext";

export default function ListComments({ children, limit }: { children: ReactNode; limit?: number }) {
    const { answersWithComments } = useQuestionResponse();

    const allComments = useMemo(() => {
        if (limit) {
            return answersWithComments.slice(0, limit);
        }
        return answersWithComments;
    }, [answersWithComments, limit]);

    return (
        <ul className="space-y-4">
            {allComments.map((answer, idx) => (
                <li key={idx} className="flex items-center gap-2 group">
                    <CommentContext.Provider value={{ answer }}>{children}</CommentContext.Provider>
                </li>
            ))}
        </ul>
    );
}
